import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import DoctorWhislistCard from "src/Components/WebsiteComponents/HomePage/Cards/DoctorWhislistCard";
import httpRequest from "src/helpers/httpRequest";
import { CURRENCY } from "src/lib/constans";
import { IPaginated } from "src/types/paginated";
import qs from "qs";
import InfinteScrollWrapper from "src/Components/GlobalComponents/Widget/InfinteScrollWrapper";
import NoItemImg from "src/assets/images/not-data/no-doctor.png";
import { useNavigate } from "react-router-dom";

const doctors: any[] = [
  {
    id: "12345",
    name: "Dr. John Smith",
    specialty: "Cardiology | Internal Medicine",
    qualification: "MBBS, MD",
    experience: "120", // 120 months (10 years)
    reviews: 150,
    rating: 4.5,
    price: 200,
    currency: CURRENCY,
    image: "https://example.com/doctor-john-smith.jpg",
  },
  {
    id: "12345",
    name: "Dr. John Smith",
    specialty: "Cardiology | Internal Medicine",
    qualification: "MBBS, MD",
    experience: "120", // 120 months (10 years)
    reviews: 150,
    rating: 4.5,
    price: 200,
    currency: CURRENCY,
    image: "https://example.com/doctor-john-smith.jpg",
  },
  {
    id: "12345",
    name: "Dr. John Smith",
    specialty: "Cardiology | Internal Medicine",
    qualification: "MBBS, MD",
    experience: "120", // 120 months (10 years)
    reviews: 150,
    rating: 4.5,
    price: 200,
    currency: CURRENCY,
    image: "https://example.com/doctor-john-smith.jpg",
  },
];

interface IObj {
  doctorId: string;
  doctorDetails: {
    firstName: string;
    lastName: string;
    coverPhoto: string | null;
    [key: string]: any;
  };
  providersDetails: {
    education: { course: string }[];
    workExperience: string;
  };
  specializationDetails: { name: string }[];
  isLiked: boolean;
  startingPrice: number;
  allReviews: { reviews: [] }[];
  averageStar: number;
}
interface IResponse {
  documents: IObj[];
  paginated: IPaginated;
}

interface Doctor {
  id: string;
  name: string;
  specialty: string;
  qualification: string;
  experience: string;
  reviews: number;
  rating: number;
  price: number;
  currency: string;
  image: string;
  [key : string] : any;
}

const DoctorWhishList = ({ onClose }: { onClose: () => void }) => {
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [data, setData] = useState<Doctor[]>([]);
  const [paginated, setPaginated] = useState<IPaginated>({
    currentPage: 1,
    totalPages: 1,
  });
  const [queryParams, setQueryParams] = useState<{
    page: number;
    limit: number;
    bool: boolean;
  }>({
    page: 1,
    limit: 10,
    bool: false,
  });

  const navigate = useNavigate();


  const fetch = async (params: Partial<typeof queryParams>) => {
    setIsLoader(true);
    const { bool, ...actulaParams } = params;
    const { res, err } = await httpRequest<IResponse>({
      path: `/provider/get/fav-doctors?${qs.stringify(actulaParams)}`,
    });
    if (res) {
      let data = res?.documents.map((item) => ({
        id: item?.doctorId,
        isLiked: true,
        experience: item?.providersDetails?.workExperience || "0",
        name: item?.doctorDetails?.firstName || item?.doctorDetails?.lastName ? `${item?.doctorDetails?.firstName} ${item?.doctorDetails?.lastName}` : "Unknown",
        specialty: item?.specializationDetails?.slice(0, 2).map((v: { name: string }) => v?.name).join(" | ") || "-",
        qualification: item?.providersDetails?.education?.map((v: { course: string }) => v?.course).join(", ") || "-",
        rating: item?.averageStar || 0,
        price: item?.startingPrice || 0,
        currency: CURRENCY,
        image: item?.doctorDetails?.coverPhoto || "",
        reviews: item?.allReviews?.length || 0,
      }))
      setData(prev => [...prev, ...data]);
      setPaginated(res?.paginated);
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };

  const handleQueryParamsChange = (
    params: Partial<typeof queryParams>,
    reset = true
  ) => {
    let updatedParams = { ...queryParams, ...params };
    setQueryParams(updatedParams);
    if (reset) {
      setPaginated({
        currentPage: 1,
        totalPages: 1,
      });
      updatedParams.page = 1;
      setData([]);
    }
    fetch(updatedParams);
  };

  
  const handleRemove = (obj: { productId: string }) => {
    if (data?.length > 1) {
      setData((prev) => prev?.filter((v) => v?.id !== obj?.productId));
    } else {
      handleQueryParamsChange({ page: queryParams?.page > 1 ? queryParams?.page - 1 : queryParams?.page });
    }
  };

  useEffect(() => {
    handleQueryParamsChange(queryParams);
  }, []);

  return (
    <>
      <InfinteScrollWrapper
        isLoading={isLoader}
        length={data?.length}
        currentPage={queryParams?.page}
        totalPages={paginated?.totalPages}
        onLoadMore={(page) => {
          handleQueryParamsChange({ page: page }, false);
        }}
        isLoadButton={true}
        noDataOptions={{
          text: "No Doctors Found",
          text2:
            "Your doctors wishlist is empty. Explore and save doctors for quick access.",
          iconImagePath: NoItemImg,
          buttonOnPress: () => {
            onClose();
            navigate("/consult-a-doctor");
          },
          buttonText: "Discover Doctors",
        }}
        calculateHeight
        itemClassName=".tab-slider-container-main"
      >
        {data.map((doctor, index) => (
          <DoctorWhislistCard
            key={`${doctor.id}-${index}`}
            doctor={doctor}
            heart_id={`heart-${index}`}
            button_id={`button-${index}`}
            onClose={onClose}
            handleRemove={() => handleRemove({ productId: doctor?.id })}
          />
        ))}
      </InfinteScrollWrapper>
    </>
  );
};

export default DoctorWhishList;
